import React, { Fragment, useCallback, useContext, useMemo } from 'react';
import { LocalizationContext } from 'app/localization/Context';
import { GatewayDataContext } from 'app/home/Home';
import { MiniPlayer } from 'app/home/overlay-pages/device/deivce-detail/device-control/audio-controller/AudioControllerPlayer';
import { AmplifierMode } from 'app/model/Device';
import { HistoryStackContext } from 'app/home/general-components/HistoryStackContext';

import { ReactComponent as IconDisconnect } from 'images/general/disconnect.svg';
import { ReactComponent as IconOn } from 'images/device/audio-controller/on.svg';
import { ReactComponent as IconPlaylistEdit } from 'images/device/audio-controller/playlist-edit.svg';
import { ReactComponent as IconTickWhite } from 'images/general/tick-white.svg';
import { ReactComponent as IconAudioController } from 'images/device/symbol/hinava_gradient/audio-controller.svg';

import './AudioControllerContents.scss';

export function AudioControllerContents({ device, showStates }) {
    const hs = useContext(HistoryStackContext);
    const l = useContext(LocalizationContext);
    const s = l.strings;
    const a = s.audioController;

    const gw = useContext(GatewayDataContext);
    const currentUser = gw.gateway.currentUser;

    const connected = (device.active === true);
    const on = (device.is_on === true);
    const hinavaMode = (device.mode === AmplifierMode.hinava);
    const withTrackList = (device.track_list !== undefined) && (device.track_list.length > 0);

    const [currentTrackName, currentTrackArtists] = useMemo(() => {
        if (withTrackList) {
            if ((device.track_list_pointer !== undefined) &&
                (device.track_list_pointer >= 0) &&
                (device.track_list_pointer < device.track_list.length)) {
                return [
                    device.track_list[device.track_list_pointer]["name"],
                    device.track_list[device.track_list_pointer]["artists"]
                ];
            }
        }
        return [undefined, undefined];
    }, [device, withTrackList]);

    const selectMusicListH = useCallback(() => {
        hs.push(
            "/devices/detail/select-music-list",
            { deviceMac: device.mac, connected })
    }, [device.mac, connected, hs]);

    if (!showStates) { // TODO: symbolic
        return <IconAudioController className="audio-controller-content symbolic-icon" />
    } else if (connected && on && hinavaMode && withTrackList) {
        return <Fragment>
            <TrackInfo name={currentTrackName} artists={currentTrackArtists} />
            <MiniPlayer device={device} />
        </Fragment>;
    } else if (connected && on && hinavaMode && !withTrackList) {
        return <CenterInfo
            l={l}
            onClick={currentUser.permissions.device.change_state ? selectMusicListH : undefined}
            infoText={a.currentPlaylistEmpty}
            buttonText={a.currentPlaylistEdit}
            buttonIcon={IconPlaylistEdit} />;
    } else if (connected && on && !hinavaMode) {
        return <Fragment>
            <LeftInfo
                l={l}
                onClick={() => { device.changeState({ mode: AmplifierMode.hinava }) }}
                infoText={a.modeIsNotHinava}
                buttonText={a.setHinavaMode}
                buttonIcon={IconTickWhite} />
            <MiniPlayer device={device} />
        </Fragment>;
    } else if (connected && !on) {
        return <CenterInfo
            l={l}
            onClick={() => { device.changeState({ is_on: true }) }}
            infoText={a.deviceIsOff}
            buttonText={a.turnDeviceOn}
            buttonIcon={IconOn} />;
    } else if (!connected && withTrackList) {
        return <Fragment>
            <DCTag l={l} s={s} />
            <TrackInfo name={currentTrackName} artists={currentTrackArtists} />
            <MiniPlayer device={device} />
        </Fragment>;
    } else if (!connected && !withTrackList) {
        return <Fragment>
            <DCTag l={l} s={s} />
            <CenterInfo
                l={l}
                onClick={currentUser.permissions.device.change_state ? selectMusicListH : undefined}
                infoText={a.currentPlaylistEmpty}
                buttonText={a.currentPlaylistEdit}
                buttonIcon={IconPlaylistEdit} />
        </Fragment>;
    }

    return null;
}

function TrackInfo({ name, artists }) {
    return (
        <div className="audio-controller-content track-info">
            <div className="name">{name}</div>
            <div className="artists">{artists}</div>
        </div>
    )
}

function LeftInfo({ l, onClick, infoText, buttonText, buttonIcon }) {
    return (
        <div className="audio-controller-content left-info"
            dir={l.isRTL ? "rtl" : "ltr"}
            lang={l.language}>
            <div className="info-text">{infoText}</div>
            <div className="button" onClick={onClick}>
                <div className="text">{buttonText}</div>
                {React.createElement(buttonIcon, { className: "icon" })}
            </div>
        </div>
    )
}

function CenterInfo({ l, onClick, infoText, buttonText, buttonIcon }) {
    return (
        <div className="audio-controller-content center-info"
            dir={l.isRTL ? "rtl" : "ltr"}
            lang={l.language}>
            <div className="info-text">{infoText}</div>
            <div className="button" onClick={onClick}>
                <div className="text">{buttonText}</div>
                {React.createElement(buttonIcon, { className: "icon" })}
            </div>
        </div>
    )
}

function DCTag({ l, s }) {
    return (
        <div className="audio-controller-content dc-tag"
            dir={l.isRTL ? "rtl" : "ltr"}
            lang={l.language}>
            <div className="label">{s.deviceDC}</div>
            <IconDisconnect className="icon" />
        </div>
    )
}